module.exports = __webpack_public_path__ + "static/media/portugal.70a47eed.svg";